<template>
    <div class="source_price_block">
        <div class="form-group mt-2">
            <label class="form-label" for="wlocal">
                {{__t("SOURCE_PRICE")}}*
            </label>

            <div class="" v-if="sources.length > 0">
                <v-select v-model="active_source"
                          class="imc_reasons"
                          label="name"
                          :options="this.sources"
                          :filter="searchSource"
                >
                    <template slot="no-options">
                        {{__t("CHOICE_REST")}}
                    </template>

                    <template slot="option" slot-scope="option">
                        <div class="d-center">
                            <div>
                                {{ option.name }}
                            </div>
                            <div>
                                <small>
                                    {{option.id}}
                                </small>
                            </div>
                        </div>
                    </template>
                </v-select>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import Fuse from 'fuse.js';
export default {
    name: "location_source_price",
    components : {
        vSelect
    },
    props : {
        location : {
            type : Object
        }
    },
    data() {
        return {
            is_load : false,
            sources : []
        }
    },

    created() {
        this.load_sources();
    },

    methods : {
        searchSource (options, search) {
            const fuse = new Fuse(options, {
                keys: ['id', 'name'],
                shouldSort: true,
            })
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list

        },

        async load_sources() {
            this.sources = [];
            await pos_api.get('/'+this.pos_provider+'/sources').then(({data}) => {
                if (data.status === "operation_success") {
                    this.sources = data.data;
                }
            }).catch(({response}) => {
              //  EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    },
    computed : {

        pos_provider() {
            try {
                if (this.location.hasOwnProperty("organization")) {
                    let org = this.location.organization;
                    return  org.provider.replace('_org','');
                }
            }
            catch (e) {

            }

            return 'poster';
        },


        active_source : {
            get :function () {
                let active = null;
                if(this.sources.length > 0) {
                    if(this.location.hasOwnProperty("source_id")) {
                        this.sources.map(item => {
                            if(item.id == this.location.source_id) {
                                active = item;
                            }
                        })
                    }
                }

                return active;
            },

            set: function (val){
                if(val != null) {
                    if (this.location.hasOwnProperty("source_id")) {
                        this.location.source_id = val.id;
                    }
                }
                else {
                    this.location.source_id = 0;
                }
            },
        },
    }
}
</script>

<style scoped>

</style>
